/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=950a4386&scoped=true"
import script from "./Dashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./Dashboard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=950a4386&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "950a4386",
  null
  
)

export default component.exports